import React, { useEffect, useRef } from "react";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import styles from "./referrerList.module.scss";
import { useSelector } from "react-redux";
import { useState } from "react";
import InputName from "../../common/Input/InputName";
import InputEmail from "../../common/Input/InputEmail";
import InputNumber from "../../common/Input/InputPhNumber";

const AddUpdateReferrerList = ({
  showModals,
  setshowModals,
  userFormData,
  handleChanges,
  handleAddUpdate,
  isMode,
  handleSelectChange,
  services,
  setUserFormData,
  handleAddField,
  handleRemoveField,
  handleSetPhoneNumber,
  userInput,
  setInputError,
  handleCloseModal,
}) => {
  const [showResult, setShowResult] = useState(true);
  const searchInputRef = useRef(null);
  const searchResultRef = useRef(null);
  const { users } = useSelector((state) => state.users);
  const takenServiceIds =
    userFormData?.referalDetails?.map((detail) =>
      detail.serviceId.toString()
    ) || [];
  const availableServices = services?.filter(
    (service) => !takenServiceIds.includes(service._id.toString())
  );

  const handleClickOutside = (event) => {
    if (
      searchInputRef.current &&
      !searchInputRef.current.contains(event.target) &&
      searchResultRef.current &&
      !searchResultRef.current.contains(event.target)
    ) {
      setShowResult(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  });

  return (
    <>
      <Modal centered show={showModals} onHide={handleCloseModal} size="lg">
        <div className="modal-header">
          <h5 className="modal-title">
            {isMode ? "EDIT REFERRER" : "ADD REFERRER"}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={handleCloseModal}
          ></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleAddUpdate}>
            <div className="row">
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <InputNumber
                    label="Phone Number"
                    value={userFormData?.phone || ""}
                    ref={searchInputRef}
                    placeholder="Number"
                    name="phone"
                    required={true}
                    onChange={(e) => handleChanges(e, "searchUser")}
                    onFocus={() => userFormData?.phone && setShowResult(true)}
                    setInputNumberError={setInputError}
                  />
                  {userFormData?.phone?.length > 0 && showResult && (
                    <div
                      className={styles.recommendations}
                      style={{ height: users?.length > 7 ? "12.2rem" : "auto" }}
                      ref={searchResultRef}
                    >
                      {users?.length > 0 ? (
                        users?.map((item, inx) => (
                          <p
                            className={styles.recommendationList}
                            key={inx}
                            onClick={() => handleSetPhoneNumber(item, "phone")}
                          >
                            {item?.phone}
                          </p>
                        ))
                      ) : (
                        <p className={styles.recommendationList}>
                          No result found
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <InputName
                    label="Referrer Name"
                    value={userFormData.name}
                    placeholder="Name"
                    name="name"
                    onChange={(e) => handleChanges(e)}
                    readOnly={userInput?.name ? true : false}
                    setInputNameError={setInputError}
                    required={true}
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <InputEmail
                    label="Referrer Email"
                    value={userFormData.email}
                    placeholder="Email"
                    name="email"
                    onChange={(e) => handleChanges(e)}
                    readOnly={userInput.email ? true : false}
                    setInputEmailError={setInputError}
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label htmlFor="status" className="col-form-label me-3">
                    Status:
                  </label>
                  <div className="d-flex align-items-center gap-4">
                    {["Active", "Inactive", "Deleted"].map((status) => (
                      <div className="form-check me-3" key={status}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="status"
                          id={status.toLowerCase()}
                          value={status}
                          checked={userFormData.status === status}
                          onChange={handleChanges}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={status.toLowerCase()}
                        >
                          {status}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {userFormData?.referalDetails?.map((field, index) => (
                <>
                  <div className="col-xl-6">
                    <div className="form-group">
                      <label className="col-form-label">Service:</label>
                      <Select
                        name="serviceId"
                        value={
                          field.serviceId
                            ? {
                                value: field.serviceId,
                                label: field.serviceName,
                              }
                            : null
                        }
                        options={availableServices?.map((service) => ({
                          value: service?._id,
                          label: service?.serviceName,
                        }))}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, index)
                        }
                      />
                    </div>
                  </div>
                  <div className="col-xl-5">
                    <div className="form-group">
                      <label className="col-form-label">
                        Referral Percentage:
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Referral Percentage"
                        value={field.referalPercentage}
                        onChange={(e) => {
                          const value = e.target.value;
                          setUserFormData((prev) => {
                            const updatedReferalDetails = [
                              ...prev.referalDetails,
                            ];
                            updatedReferalDetails[index].referalPercentage =
                              value;
                            return {
                              ...prev,
                              referalDetails: updatedReferalDetails,
                            };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-xl-1 mt-4 pt-3 d-flex gap-2">
                    <FaPlusCircle
                      className="fs-3 mt-2 text-primary"
                      onClick={handleAddField}
                      title="Add New Service"
                    />

                    {userFormData.referalDetails.length > 1 && (
                      <FaMinusCircle
                        className="fs-3 mt-2 text-danger"
                        onClick={() => handleRemoveField(index)}
                        title="Remove This Service"
                      />
                    )}
                  </div>
                </>
              ))}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCloseModal}
              >
                Close
              </button>

              <button type="submit" className="btn btn-primary">
                {isMode ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default AddUpdateReferrerList;
